import {
  ADMIN_ADD_MANUAL_DELIVERY,
  ADMIN_ADD_MANUAL_ORDER,
  ADMIN_AGENT_TRANSACTIONS,
  ADMIN_AUDIT_LOG,
  ADMIN_BRAND_DETAILS,
  ADMIN_BRAND_MANAGE_PROVIDERS,
  ADMIN_BRAND_TEMPLATES,
  ADMIN_BRAND_TEMPLATE_MENU,
  ADMIN_BRAND_V_DRIVE,
  ADMIN_BRAND_V_DRIVE_ASSIGNMENT_STRATEGY,
  ADMIN_CHAT,
  ADMIN_CLIENT_PAYMENTS,
  ADMIN_CLOSING_DAYS,
  ADMIN_CUSTOMER_STATS,
  ADMIN_DASHBOARD,
  ADMIN_DELIVERIES,
  ADMIN_DELIVERIES_DETAILS,
  ADMIN_EDIT_MANUAL_ORDER,
  ADMIN_INCIDENT_MESSAGES,
  ADMIN_SUPPORT_TICKETS,
  ADMIN_SYSTEM_PROBLEMS,
  ADMIN_LOCATIONS,
  ADMIN_LOCATIONS_DETAILS,
  ADMIN_LOCATIONS_ONBOARDING_V_DRIVE,
  ADMIN_LOCATIONS_V_DRIVE,
  ADMIN_LOCATIONS_V_DRIVE_ASSIGNMENT_STRATEGY,
  ADMIN_LOCATION_MANAGE_PROVIDERS,
  ADMIN_MENU,
  ADMIN_ORDERS,
  ADMIN_ORDER_DETAILS,
  ADMIN_RECEIVABLES,
  ADMIN_RECEIVABLES_LOCATION,
  ADMIN_RECEIVABLES_LOCATION_OLD,
  ADMIN_RECEIVABLES_OLD,
  ADMIN_REFERRALS,
  ADMIN_REFERRAL_DETAILS,
  ADMIN_SETTINGS,
  ADMIN_SETTINGS_WHATS_NEW,
  ADMIN_NOTIFICATIONS,
  ADMIN_TRANSACTIONS,
  ADMIN_USERS,
  ADMIN_USERS_DETAILS,
  ADMIN_USER_DETAILS_AGENT,
  ADMIN_USER_DETAILS_AGENT_AGENTS,
  ADMIN_USER_DETAILS_AGENT_LOCATIONS,
  ADMIN_USER_TRANSACTIONS_PENDING_LOCATION,
  ADMIN_VERIFICATIONS,
  ADMIN_VERIFICATIONS_AGENT,
  ADMIN_VERIFICATIONS_BRAND,
  ADMIN_VERIFICATIONS_RESTAURANT,
  ADMIN_VERIFICATIONS_V_DRIVE,
  ADMIN_WORKING_HOURS,
  AddManualOrder,
  AnnouncementDetails,
  Announcements,
  AnnouncementsIcon,
  AuditLogIcon,
  BlogsAdd,
  BlogsAdmin,
  BrandTemplateMenu,
  BrandsIcon,
  ChatIcon,
  ClientPaymentsIcon,
  ClosingDays,
  ClosingDaysPageIcon,
  RestaurantReferralsIcon,
  CustomerStatsIcon,
  DashboardIcon,
  Deliveries,
  DeliveriesIcon,
  DeliveryCreateManual,
  DeliveryDetails,
  LocationsIcon,
  Menu,
  OrderDetails,
  OrderIcon,
  Orders,
  Providers,
  RouteObjectType,
  Settings,
  SettingsPageIcon,
  WhatsNew,
  Notifications,
  Transactions,
  TransactionsAgent,
  TransactionsPending,
  UserIcon,
  UserPermission,
  UserRole,
  SupportTicketsIcon,
  SystemProblemsPageIcon,
  VerificationsIcon,
  WorkingHolidayHours,
  WorkingHoursIcon,
} from '@vgrubs/components';

import {
  ADMIN_ANNOUNCEMENTS,
  ADMIN_ANNOUNCEMENT_DETAILS,
  ADMIN_BLOGS,
  ADMIN_BLOGS_ADD,
  ADMIN_BLOGS_EDIT,
  ADMIN_PRIVACY_POLICY,
  ADMIN_TERMS_AND_CONDITIONS,
} from '@vgrubs/components';
import { PrivacyPolicyEdit } from '../adminPages';
import { AuditLog } from '../adminPages/AuditLog/AuditLog';
import { SupportTickets } from '../adminPages/SupportTickets/SupportTickets';
import { BrandTemplates } from '../adminPages/BrandTemplates/BrandTemplates';
import { ClientPayments } from '../adminPages/ClientPayments/ClientPayments';
import {
  OldReceivablesRedirect,
  Receivables,
  ReceivablesLocation,
} from '../adminPages/Receivables';
import { ReferralDetails, Referrals } from '../adminPages/Referrals';
import { CustomerStats } from '../adminPages/CustomerStats/CustomerStats';
import { Dashboard } from '../adminPages/Dashboard/Dashboard';
import { BrandDetails } from '../adminPages/Locations/BrandDetails';
import { LocationDetails } from '../adminPages/Locations/LocationDetails';
import { Locations } from '../adminPages/Locations/Locations';
import { AgentList } from '../adminPages/UsersAndAccess/Agent/AgentList';
import { SignUpLocations } from '../adminPages/UsersAndAccess/Agent/SignUpLocations';
import { UserDetailsAgent } from '../adminPages/UsersAndAccess/UserDetails/UserDetailsAgent';
import { UserDetailsPage } from '../adminPages/UsersAndAccess/UserDetails/UserDetailsPage';
import { UsersAndAccess } from '../adminPages/UsersAndAccess/UsersAndAccess';
import { AssignmentStrategy } from '../adminPages/VDrive/AssignmentStrategy/AssignmentStrategy';
import { VDriveBrand } from '../adminPages/VDrive/VDriveBrand';
import { VDriveLocation } from '../adminPages/VDrive/VDriveLocation';
import { VDriveLocationOnboarding } from '../adminPages/VDrive/onboarding/VDriveLocationOnboarding';
import { AgentDetails } from '../adminPages/Verifications/AgentDetails';
import { BrandVerificationDetails } from '../adminPages/Verifications/BrandVerificationDetails';
import { RestaurantDetails } from '../adminPages/Verifications/RestaurantDetails';
import { VDriveVerificationDetails } from '../adminPages/Verifications/VDriveVerificationDetails';
import { Verifications } from '../adminPages/Verifications/Verifications';
import { Chat } from '../adminPages/Chat/Chat';
import { SystemProblems } from '../adminPages/SystemProblems';
import { IncidentMessages } from '../adminPages/IncidentMessages/IncidentMessages';

// show new pill in sidebar is in newItem: '2025-03-20' format

export const ROUTES_ADMIN: RouteObjectType[] = [
  {
    path: '/',
    permissions: [],
  },
  {
    path: ADMIN_DASHBOARD,
    Page: Dashboard,
    name: 'Dashboard',
    Icon: DashboardIcon,
    permissions: [UserRole.admin, UserRole.support],
  },
  {
    path: ADMIN_SYSTEM_PROBLEMS,
    Page: SystemProblems,
    name: 'System Problems',
    Icon: SystemProblemsPageIcon,
    /* No NEW pill: with the count beside it the name no longer fits. */
    permissions: [UserRole.admin, UserRole.support],
  },
  {
    path: ADMIN_VERIFICATIONS,
    Page: Verifications,
    name: 'Verifications',
    Icon: VerificationsIcon,
    permissions: [UserRole.admin, UserRole.support],
  },
  {
    path: ADMIN_USERS,
    Page: UsersAndAccess,
    name: 'Users',
    Icon: UserIcon,
    permissions: [UserRole.admin, UserRole.support],
  },
  {
    path: ADMIN_USER_TRANSACTIONS_PENDING_LOCATION,
    Page: TransactionsPending,
    permissions: [UserRole.admin, UserRole.support],
  },
  {
    path: ADMIN_USERS_DETAILS,
    Page: UserDetailsPage,
    permissions: [UserRole.admin, UserRole.support],
  },
  {
    path: ADMIN_USER_DETAILS_AGENT,
    Page: UserDetailsAgent,
    permissions: [UserRole.admin, UserRole.support],
  },
  {
    path: ADMIN_USER_DETAILS_AGENT_LOCATIONS,
    Page: SignUpLocations,
    permissions: [UserRole.admin, UserRole.support],
  },
  {
    path: ADMIN_USER_DETAILS_AGENT_AGENTS,
    Page: AgentList,
    permissions: [UserRole.admin, UserRole.support],
  },
  {
    path: ADMIN_TRANSACTIONS,
    Page: Transactions,
    permissions: [UserRole.admin, UserRole.support],
  },
  {
    path: ADMIN_AGENT_TRANSACTIONS,
    Page: TransactionsAgent,
    permissions: [UserRole.admin, UserRole.support],
  },
  {
    path: ADMIN_VERIFICATIONS_RESTAURANT,
    Page: RestaurantDetails,
    permissions: [UserRole.admin, UserRole.support],
  },

  {
    path: ADMIN_VERIFICATIONS_V_DRIVE,
    Page: VDriveVerificationDetails,
    permissions: [UserRole.admin, UserRole.support],
  },

  {
    path: ADMIN_VERIFICATIONS_AGENT,
    Page: AgentDetails,
    permissions: [UserRole.admin, UserRole.support],
  },

  {
    path: ADMIN_VERIFICATIONS_BRAND,
    Page: BrandVerificationDetails,
    permissions: [UserRole.admin, UserRole.support],
  },
  {
    path: ADMIN_LOCATIONS,
    Page: Locations,
    name: 'Locations',
    Icon: LocationsIcon,
    permissions: [UserRole.admin, UserRole.support],
  },
  {
    path: ADMIN_LOCATIONS_DETAILS,
    Page: LocationDetails,
    permissions: [UserRole.admin, UserRole.support],
  },
  {
    path: ADMIN_LOCATIONS_V_DRIVE,
    Page: VDriveLocation,
    permissions: [UserRole.admin, UserRole.support],
  },
  {
    path: ADMIN_LOCATIONS_V_DRIVE_ASSIGNMENT_STRATEGY,
    Page: AssignmentStrategy,
    permissions: [UserRole.admin, UserRole.support],
  },
  {
    path: ADMIN_BRAND_V_DRIVE_ASSIGNMENT_STRATEGY,
    Page: AssignmentStrategy,
    permissions: [UserRole.admin, UserRole.support],
  },
  {
    path: ADMIN_LOCATIONS_ONBOARDING_V_DRIVE,
    Page: VDriveLocationOnboarding,
    permissions: [UserRole.admin, UserRole.support],
  },
  {
    path: ADMIN_BRAND_V_DRIVE,
    Page: VDriveBrand,
    permissions: [UserRole.admin, UserRole.support],
  },
  {
    path: ADMIN_BRAND_DETAILS,
    Page: BrandDetails,
    permissions: [UserRole.admin, UserRole.support],
  },
  {
    path: ADMIN_LOCATION_MANAGE_PROVIDERS,
    Page: Providers,
    permissions: [UserRole.admin, UserRole.support],
  },
  {
    path: ADMIN_BRAND_MANAGE_PROVIDERS,
    Page: Providers,
    permissions: [UserRole.admin, UserRole.support],
  },

  {
    path: ADMIN_ORDERS,
    Page: Orders,
    name: 'Orders',
    Icon: OrderIcon,
    permissions: [UserRole.admin, UserRole.support],
  },
  {
    path: ADMIN_ORDER_DETAILS,
    Page: OrderDetails,
    permissions: [UserRole.admin, UserRole.support],
  },

  {
    path: ADMIN_ADD_MANUAL_ORDER,
    Page: AddManualOrder,
    permissions: [UserRole.admin, UserRole.support],
  },

  {
    path: ADMIN_EDIT_MANUAL_ORDER,
    Page: AddManualOrder,
    permissions: [UserRole.admin, UserRole.support],
  },

  {
    path: ADMIN_DELIVERIES,
    Page: Deliveries,
    name: 'Deliveries',
    Icon: DeliveriesIcon,
    permissions: [UserRole.admin, UserRole.support],
    // newItem: '2025-03-20',
  },

  {
    path: ADMIN_DELIVERIES_DETAILS,
    Page: DeliveryDetails,
    permissions: [UserRole.admin, UserRole.support],
  },

  {
    path: ADMIN_ADD_MANUAL_DELIVERY,
    Page: DeliveryCreateManual,
    permissions: [UserRole.admin, UserRole.support],
  },

  {
    path: ADMIN_CHAT,
    Page: Chat,
    name: 'Chat',
    Icon: ChatIcon,
    /*
     * Role only. `conversationRead` gates SUPPORT threads, not the page: an
     * internal user with no permission still belongs to their own groups and
     * direct messages, and locking them out of `/chat` would hide those too.
     * The permission is applied inside the inbox instead.
     */
    permissions: [UserRole.admin, UserRole.support, UserRole.marketing],
    newItem: '2026-08-04',
  },
  {
    path: ADMIN_SUPPORT_TICKETS,
    Page: SupportTickets,
    /* "Tickets" in the rail, "Support Tickets" on the page: the full name is
       the longest label in the sidebar and collides with the NEW pill and the
       count that sit beside it. */
    name: 'Tickets',
    Icon: SupportTicketsIcon,
    permissions: [UserRole.admin, UserRole.support, UserRole.marketing],
    /* The queue is the support inbox by another name, so it is delegated with
       the same permission - and the sidebar hides both together. */
    permission: UserPermission.conversationRead,
    newItem: '2026-09-10',
  },

  {
    path: ADMIN_CLIENT_PAYMENTS,
    Page: ClientPayments,
    name: 'Client Payments',
    Icon: ClientPaymentsIcon,
    permissions: [UserRole.admin, UserRole.support],
  },
  {
    path: ADMIN_RECEIVABLES,
    Page: Receivables,
    /* "Outstanding Balances". Not in the sidebar: the way in is the arrow
       on the Finances tab's Outstanding Balances card. Support reads it;
       every manual
       action on it is admin only, gated on the page. */
    permissions: [UserRole.admin, UserRole.support],
  },
  {
    path: ADMIN_RECEIVABLES_LOCATION,
    Page: ReceivablesLocation,
    permissions: [UserRole.admin, UserRole.support],
  },
  // The paths before the rename, so links shared earlier still land.
  {
    path: ADMIN_RECEIVABLES_OLD,
    Page: OldReceivablesRedirect,
    permissions: [UserRole.admin, UserRole.support],
  },
  {
    path: ADMIN_RECEIVABLES_LOCATION_OLD,
    Page: OldReceivablesRedirect,
    permissions: [UserRole.admin, UserRole.support],
  },
  {
    path: ADMIN_REFERRALS,
    Page: Referrals,
    name: 'Referrals',
    Icon: RestaurantReferralsIcon,
    permissions: [UserRole.admin, UserRole.support],
    newItem: '2026-10-12',
  },
  {
    path: ADMIN_REFERRAL_DETAILS,
    Page: ReferralDetails,
    permissions: [UserRole.admin, UserRole.support],
  },
  {
    path: ADMIN_CLOSING_DAYS,
    Page: ClosingDays,
    name: 'Closing Days',
    Icon: ClosingDaysPageIcon,
    permissions: [UserRole.admin, UserRole.support],
  },
  {
    path: ADMIN_WORKING_HOURS,
    Page: WorkingHolidayHours,
    name: 'Working Hours',
    Icon: WorkingHoursIcon,
    permissions: [UserRole.admin, UserRole.support],
  },
  {
    path: ADMIN_AUDIT_LOG,
    Page: AuditLog,
    name: 'Audit Log',
    Icon: AuditLogIcon,
    permissions: [UserRole.admin, UserRole.support],
  },

  {
    path: ADMIN_BRAND_TEMPLATES,
    Page: BrandTemplates,
    name: 'Brand Templates',
    Icon: BrandsIcon,
    permissions: [UserRole.admin],
  },

  {
    path: ADMIN_ANNOUNCEMENTS,
    Page: Announcements,
    name: 'Announcements',
    Icon: AnnouncementsIcon,
    permissions: [UserRole.admin, UserRole.support],
  },
  {
    path: ADMIN_ANNOUNCEMENT_DETAILS,
    Page: AnnouncementDetails,
    permissions: [UserRole.admin, UserRole.support],
  },

  {
    path: ADMIN_CUSTOMER_STATS,
    Page: CustomerStats,
    name: 'Customer Stats',
    Icon: CustomerStatsIcon,
    permissions: [UserRole.admin, UserRole.support],
  },

  {
    path: ADMIN_SETTINGS,
    Page: Settings,
    name: 'Settings',
    Icon: SettingsPageIcon,
    permissions: [UserRole.admin, UserRole.support],
  },

  {
    path: ADMIN_BLOGS,
    Page: BlogsAdmin,
    name: 'Blogs',
    permissions: [UserRole.admin, UserRole.support, UserRole.marketing],
  },

  {
    path: ADMIN_BLOGS_ADD,
    Page: BlogsAdd,
    permissions: [UserRole.admin, UserRole.support, UserRole.marketing],
  },
  {
    path: ADMIN_BLOGS_EDIT,
    Page: BlogsAdd,
    permissions: [UserRole.admin, UserRole.support, UserRole.marketing],
  },

  {
    path: ADMIN_TERMS_AND_CONDITIONS,
    Page: PrivacyPolicyEdit,
    permissions: [UserRole.admin],
  },
  {
    path: ADMIN_PRIVACY_POLICY,
    Page: PrivacyPolicyEdit,
    permissions: [UserRole.admin],
  },
  {
    path: ADMIN_SETTINGS_WHATS_NEW,
    Page: WhatsNew,
    permissions: [UserRole.admin, UserRole.support],
  },
  {
    // The bell's See all. No `name`: reached from the bell on the main
    // screens, so it stays out of the sidebar (and wears no bell itself).
    path: ADMIN_NOTIFICATIONS,
    Page: Notifications,
    permissions: [UserRole.admin, UserRole.support],
  },

  {
    path: ADMIN_MENU,
    Page: Menu,
    permissions: [UserRole.admin, UserRole.support],
  },
  {
    path: ADMIN_INCIDENT_MESSAGES,
    Page: IncidentMessages,
    permissions: [UserRole.admin, UserRole.support],
  },
  {
    path: ADMIN_BRAND_TEMPLATE_MENU,
    Page: BrandTemplateMenu,
    permissions: [UserRole.admin, UserRole.support],
  },
];
